// const backend = 'http://anmooo.com:3700/';
const backend = '/api/';
const admin = backend + 'admin/';
const annual_target = backend + 'annualtarget/';
const art = backend + 'art/';
const art_type = backend + 'arttype/';
const cate_type = backend + 'catetype/';
const consult = backend + 'consult/';
const course = backend + 'course/';
const discount = backend + 'discount/';
const login = backend + 'login/';
const logout = backend + 'logout/';
const member = backend + 'member/';
const member_page = (page, rows) => `${member}p/${page}/${rows}`;
const member_count = `${member}count`;
const member_search = (page, rows) => `${member}search/${page}/${rows}`;
const mou = backend + 'mou/';
const news = backend + 'news/';
const news_page = (page, rows) => `${news}p/${page}/${rows}`;
const order = backend + 'order/';
const order_by_memberId = order + 'm/';
const consult_by_memberId = consult + 'm/';
const partner = backend + 'partner/';
const product = backend + 'product/';
const point = backend + 'point/';
const point_count = `${point}count`;
const point_page = (page, rows) => `${point}p/${page}/${rows}`;
const extend = backend + 'extend/';
const extend_count = `${extend}count`;
const extend_page = (page, rows) => `${extend}p/${page}/${rows}`;
const book = backend + 'book/';
const book_count = `${book}count`;
const book_page = (page, rows) => `${book}p/${page}/${rows}`;
const add = backend + 'add/';
const add_count = `${add}count`;
const add_page = (page, rows) => `${add}p/${page}/${rows}`;
const eve = backend + 'eve/';
const eve_count = `${eve}count`;
const eve_page = () => `${eve}page`;
const evaluate_by_memberId = `${eve}byMemberId/`;
const admlog = backend + 'admlog/';
const admlog_count = `${admlog}count`;
const admlog_page = (page, rows) => `${admlog}p/${page}/${rows}`;
const qa = backend + 'qa/';
const qa_cma = (page, rows) => `${qa}cma/${page}/${rows}`;
const qa_cpa = (page, rows) => `${qa}cpa/${page}/${rows}`;
const qa_search = (page, rows) => `${qa}search/${page}/${rows}`;
const report = backend + 'report/';
const teacher = backend + 'teacher/';
const share = art + 'share/';
const share_page = (page, rows) => `${share}p/${page}/${rows}`;
const userfiles = backend + 'userfiles/';
const userfiles_memberUpload = userfiles + 'member/upload';
const userfiles_teacherUpload = userfiles + 'teacher/upload';
const userfiles_extendUpload = userfiles + 'extend/upload';

// ==== notes endpoints ====
const userfilesNotesBase = `${backend}userfiles/notes`;
const userfiles_notes_list   = (user_type, user_id) => `${userfilesNotesBase}/${user_type}/${user_id}`;
const userfiles_notes_create = `${userfilesNotesBase}`;
const userfiles_notes_update = (id) => `${userfilesNotesBase}/${id}`;
const userfiles_notes_delete = (id) => `${userfilesNotesBase}/${id}`;

const video = art + 'video/';
const video_page = (page, rows) => `${video}p/${page}/${rows}`;

const frontend = 'https://www.beckertw.com/';
const adm = 'adm/';
const file_upload = frontend + adm + 'admfiles/';
const member_edit = frontend + adm + 'admmemberedit/';

module.exports = {
  backend,
  admin,
  annual_target,
  art,
  art_type,
  cate_type,
  consult,
  consult_by_memberId,
  course,
  discount,
  login,
  logout,
  member,
  member_page,
  member_count,
  member_search,
  mou,
  news,
  news_page,
  order,
  order_by_memberId,
  partner,
  product,
  point,
  point_page,
  point_count,
  extend,
  extend_page,
  extend_count,
  book,
  book_page,
  book_count,
  add,
  add_page,
  add_count,
  eve,
  eve_page,
  eve_count,
  evaluate_by_memberId,
  admlog,
  admlog_page,
  admlog_count,
  qa,
  qa_cma,
  qa_cpa,
  qa_search,
  report,
  teacher,
  share,
  share_page,
  video,
  video_page,
  userfiles,
  userfiles_memberUpload,
  userfiles_teacherUpload,
  userfiles_extendUpload,
  userfiles_notes_list,
  userfiles_notes_create,
  userfiles_notes_update,
  userfiles_notes_delete,
  // 前後端分隔線
  frontend,
  adm,
  file_upload,
  member_edit,
};
